import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';
import { HttpClient } from "@angular/common/http";

@Injectable()
export class NotificationSettingsService extends BaseService{

  apiUrl = "NotificationSettings.php?"

  constructor(protected http: HttpClient) {
    super(http);
  }

  setMailFlags(dealFlags: string, sessionToken: string, country: string) {
    let url = this.serverUrl + this.apiUrl;
    let params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "setMailFlags"),
      new UrlParam("flags", dealFlags),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  getMailFlags(sessionToken: string, country: string) {
    let url = this.serverUrl + this.apiUrl +
    this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "getMailFlags"),
      new UrlParam("sessionToken", sessionToken),
    );
    return this.get(url);
  }

}
